import { Injectable, inject } from '@angular/core'
import { MatSnackBar, type MatSnackBarRef } from '@angular/material/snack-bar'
import { SnackbarComponent } from '@core/snackbar/snackbar.component'
import { THEME_STYLES, type THEME_TYPE } from '@core/type/theme'
import { IS_NUMERIC } from '@core/util/check.util'
import { TO_NUMBER } from '@core/util/convert.util'

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  MatSnackBar = inject(MatSnackBar)

  public panelClass = THEME_STYLES.reduce((o, s) => ({ ...o, [s]: [`snackbar_${s}`] }), {})

  public closeClass = Object.keys(this.panelClass).reduce((o, s) => ({ ...o, [s]: [`bg_${s}`] }), {})

  emptyString = ''

  X = 'close'

  /**
   * by default: show info message
   */
  show (_: { message: any, type?: THEME_TYPE, duration?: number, closeWith?: string, closeType?: THEME_TYPE }): MatSnackBarRef<SnackbarComponent> {
    const type = _.type

    const panelClass = this.panelClass[type ?? 'info']

    const message = _.message

    let duration = TO_NUMBER(_.duration)

    const closeWith = _.closeWith
    const closeString = closeWith ?? ((Infinity === duration) ? this.X : this.emptyString)

    const closeType = _.closeType
    const closeClass = this.closeClass[closeType ?? type ?? 'info']

    duration = IS_NUMERIC(duration) ? duration : (3 * 1e3)

    const data = { panelClass, message, closeString, closeClass, duration }

    return this.MatSnackBar.openFromComponent(SnackbarComponent, { data, duration })
  }

  showDanger (message = 'Danger'): MatSnackBarRef<SnackbarComponent> {
    return this.show({ message, type: 'danger', duration: 30000, closeWith: this.X })
  }

  showWarn (message = 'Warn'): MatSnackBarRef<SnackbarComponent> {
    return this.show({ message, type: 'warn', duration: 10 * 1000, closeWith: this.X })
  }

  showInfo (message = 'Info'): MatSnackBarRef<SnackbarComponent> {
    return this.show({ message, type: 'info', duration: 3 * 1000, closeWith: this.X })
  }

  showSuccess (message = 'Success'): MatSnackBarRef<SnackbarComponent> {
    return this.show({ message, type: 'success', duration: 8 * 1000, closeWith: this.X })
  }

  showDefaultServerError (): MatSnackBarRef<SnackbarComponent> {
    return this.showDanger('Server error, please try again later')
  }
}
